import React, { useContext } from "react";
import Applayout from "./layout/applayout";

import AuthContext from "../context/AuthContext";
import ProjectOfficer from "./dashboard/projectOfficer";
import CaseManager from "./dashboard/caseManager";
import ProjectManager from "./dashboard/projectManager";
import SuperAdmin from "./superadmin";


function Page() {
  const {user} = useContext(AuthContext)

  return (
    <Applayout>

      {user.user_type === 'project_officer' && <ProjectOfficer />}
      {user.user_type === 'case_manager' && <CaseManager />}
      {user.user_type === 'project_manager' && <ProjectManager />}
      {(user.user_type === 'super_admin' || user.user_type === 'admin') && <SuperAdmin />}

    </Applayout>
  );
}

export default Page;
